import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-auto-unlock-lessons',
  templateUrl: './auto-unlock-lessons.component.html',
  styleUrls: ['./auto-unlock-lessons.component.css']
})
export class AutoUnlockLessonsComponent implements OnInit {
  @Input() authLevel;
  constructor() {

   }

  ngOnInit(): void {
    // console.log(this.authLevel)
  }
  ngAfterViewInit(){
    // console.log(this.authLevel)
  }

}
